import React from "react";
import "./Portfolio.css";

export default function Portfolio() {
  return (
    <>
      <div id="portfolio" className="text-center text-white kajal p-sm-0">
        <div
          style={{ Position: "relative" }}
          className="container-fluid p-sm-5"
        >
          <h5 data-aos="zoom-in-up" className="heading my-5">
            Portfolio
          </h5>
          <p data-aos="zoom-in-right">
            A coding portfolio should include 4-10 coding projects. Coders
            should always choose projects that showcase their best work, even if
            that means showing fewer projects in the portfolio. Coders should
            also consistently update their portfolio projects to ensure they
            show their most current work to employers.
          </p>
        </div>
        <div class="container-fluid p-sm-5">
          <div class="row">
            <div class="col-sm-4 col-md-6 col-lg-4 mb-3 mb-lg-0">
              <img
                data-aos="zoom-in-up"
                style={{ objectFit: "cover" }}
                src="Images/singleio1.jpg"
                alt="Bobby Kumar"
                height="400px"
                width="100%"
              />
            </div>
            <div class="col-sm-4 col-md-6 col-lg-4 mb-3 mb-lg-0">
              <img
                data-aos="zoom-in-up"
                style={{ objectFit: "cover", objectPosition: "center top" }}
                src="Images/gdg2.jpg"
                alt="Bobby io"
                height="400px"
                width="100%"
              />
            </div>
            <div class="col-sm-4 col-md-12 col-lg-4 mb-3 mb-lg-0">
              <img
                data-aos="zoom-in-up"
                style={{ objectFit: "cover" }}
                src="Images/gdg1.jpg"
                alt="Bobby yadav"
                height="400px"
                width="100%"
              />
            </div>
          </div>
        </div>
      </div>
      <hr style={{ border: "1px solid white" }} className="my-0" />
    </>
  );
}
